// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"c02df8bb","545":"58e71eaa","787":"cda612ba"}[chunkId] + ".chunk.js";
};